import {API_URL, apiPost} from '../api'

export const revokeBadge = async (badgeId: string, userIds: string[]) => {
    return await apiPost(API_URL, `admin/badges/${badgeId}/revoke`, {user_ids: userIds})
}
